/* eslint-disable no-unused-vars */
// /* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Accordion,
  Button,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Form,
  Modal,
  Row
} from 'react-bootstrap';
import MyModal from './scheduleForm';
import { Alert } from 'react-bootstrap';
import alarm from './alarm/emergency-alarm-with-reverb-29431.mp3';
import useHttpApiCall from '../../services/useHttpApiCall';
import TimePicker from 'react-time-picker';
import "react-time-picker/dist/TimePicker.css";

const Schemas = () => {
  // const [schedulePayload, setSchedulePayload] = useState([]);
  const [payloadSlideShows, setPayloadSlideShows] = useState(undefined);
  const [showModal, setShowModal] = useState(false);
  // const [payloadEquipments, setPayloadEquipments] = useState(undefined);
  const [dataProps, setDataProps] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [editForm, setEditForm] = useState(false);
  const [deleteModalVisibility, setDeleteModalVisibility] = useState(false);
  const [deletedItem, setDeletedItem] = useState({});
  const [showToast, setShowToast] = useState(false);
  //const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    !showModal &&
      setPayloadSlideShows({
        auth: true,
        url: 'v0/shop-floor-view/schedules/'
      });
  }, [showModal]);
  const handleShow = () => {
    setShowModal(true);
    setDataProps({});
  };
  const handleClose = () => {
    setShowModal(false);
    setEditForm(false);
    setDataProps({});
  };

  const [deletePayload, setDeletePayload] = useState(undefined);
  var [data] = useHttpApiCall(deletePayload);
  // const [equipments, setEquipments] = useState([]);
  const [audio] = useState(new Audio(alarm));

  // const [data] = useHttpApiCall(payloadEquipments)
  const data1 = useHttpApiCall(payloadSlideShows);
  useEffect(() => {
    setPayloadSlideShows({
      auth: true,
      url: 'v0/shop-floor-view/schedules/'
    });
  }, []);
  useEffect(() => {
    data?.status == 204 &&
      setPayloadSlideShows({
        auth: true,
        url: 'v0/shop-floor-view/schedules/'
      });
    data?.status == 204 && setDeletePayload({});
  }, [data, data1]);

  // useEffect(() => {
  //   setPayloadEquipments({
  //     auth: true,
  //     url: 'v0/equipments/'
  //   });

  // }, []);
  // useEffect(()=>{
  //   if(data && data?.data){
  //     setEquipments(data?.data?.data)
  //   }
  // },[data])
  const reloadData = () => {
    setPayloadSlideShows({
      auth: true,
      url: 'v0/shop-floor-view/schedules/'
    });
  };

  const handleAddClick = (item) => {
    if (item == null) {
      setDataProps({});
      setShowModal(true);
      setEditForm(false);
    } else {
      setDataProps(item);
      setShowModal(true);
      setEditForm(true);
    }
  };
  const handleDelete = (item) => {
    setDeletedItem(item);
    setDeleteModalVisibility(true);
  };
  const onAlertDeleteConfirm = () => {
    setDeletePayload({
      auth: true,
      url: `v0/shop-floor-view/schedules/${deletedItem?.id}/`,
      method: 'DELETE'
    });
  };

 //to show success delete message
  useEffect(() => {
    if (data?.status === 204) {
   
      setShowToast(true);
    }
    const timer = setTimeout(() => {
      setShowToast(false);
    }, 4000);
  }, [data]);
  const handleEditClick = (item) => {
    setDataProps(item);
    setShowModal(true);
    setEditForm(true);
  };

  // Create a new audio object
  // const audio = new Audio('../alarm/emergency-alarm-with-reverb-29431.mp3'); // Replace with your sound file path
  const playSound = () => {
    audio.play();
  };
  const handleCloseDeleteModal = () => {
    setDeletedItem({});
    setDeleteModalVisibility(false);
  };

  const CardView = ({ item, index }) => {
    return (
      <div key={index}>
        <Row className="cards  p-3 pt-3">
          <Col xs={10} aria-disabled>
            <input
              name="name"
              className="shadow rounded form-control shadow border-0 py-4 my-3 pl-1 rounded clientInput schedule_name"
              disabled
              style={{ marginBottom: '10px' }}
              value={item?.name}
            />
            <div className="d-flex flex-wrap day_button_container my-3">
              {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => (
                <Button
                  key={day}
                  variant={
                    item.schedule_time
                      ?.map((schedule_days) => schedule_days?.schedule_day)
                      ?.includes(index + 1)
                      ? 'success'
                      : 'secondary'
                  }
                  className="m-1 day_button"
                  disabled>
                  {day.charAt(0).toUpperCase() + day.slice(1)}
                </Button>
              ))}
            </div>
            {/* --------------------------------timer----------------------------- */}
            <div>
              {/* Time range */}
              <Form.Group controlId="formTime" >
                <Form.Label className="d-block">Enter Time</Form.Label>
             <div className="d-flex">
                <TimePicker
                  className="me-3 rounded-timepicker-schema" 
                  format="HH:mm"
                  disableClock={true}
                  clearIcon={null}
                  
                  value={item?.schedule_time?.[0]?.schedule_from_time?.slice(0, 5)}
                  disabled
                  // onChange={(e) => handleTimeChange(e, 'schedule_from_time')}
                />
                <TimePicker
                 className="rounded-timepicker-schema" 
                  format="HH:mm"
                   disableClock={true}
                  clearIcon={null}
                  value={item?.schedule_time?.[0]?.schedule_to_time?.slice(0, 5)}
                  disabled
                  // onChange={(e) => handleTimeChange(e, 'schedule_to_time')}
                />
                </div>
              </Form.Group>
            </div>
            <div className="shopfloor-quotes my-3 pt-3">
              Select machine state <span>(Machine state is based on machine status setting)</span>
            </div>
            <div>
              <Form.Group controlId="formStatus">
                {/* <h5>Status</h5> */}
                <DropdownButton
                  variant="secondary"
                  name="machine_status"
                  id="dropdown-basic-button"
                  title={
                    item?.machine_status?.charAt(0).toUpperCase() + item?.machine_status?.slice(1)
                  }
                  // onSelect={handleDropdownChange}
                  // value={scheduleParams?.machine_status}
                  defaultValue={'OFF'}
                  disabled>
                  <Dropdown.Toggle id="dropdown-button-dark-example1" variant="secondary">
                    {item?.machine_status}
                  </Dropdown.Toggle>
                  <Dropdown.Item eventKey="PRODUCTION">PRODUCTION</Dropdown.Item>
                  <Dropdown.Item eventKey="OFF">OFF</Dropdown.Item>
                  <Dropdown.Item eventKey="SLEEP">SLEEP</Dropdown.Item>
                  <Dropdown.Item eventKey="STANDBY">STANDBY</Dropdown.Item>
                </DropdownButton>
              </Form.Group>
              <Form.Group controlId="formStatus" className="d-flex align-items-center my-3">
                <h5 className="schedule-label">Should be</h5>
                <div>
                  {/* <label className="mt-4 mb-2  modal-label">Machine Status condetion</label> */}
                  <div className="text-left px-3" disabled>
                    <label className="daz-switch  mt-1">
                      <input
                        type="checkbox"
                        // onChange={() => { handleChange({ target: { name: 'machine_status_condition', value: !scheduleParams.machine_status_condition } }) }}
                        disabled
                        checked={item?.machine_status_condition == 'SHOULD_BE'}
                      />
                      <span disabled className="slider round"></span>
                    </label>
                  </div>
                </div>
                <h5 className="schedule-label">Should not be</h5>
                <div>
                  {/* <label className="mt-4 mb-2  modal-label">Machine Status condetion</label> */}
                  <div className="text-left px-3" disabled>
                    <label className="daz-switch mt-1">
                      <input
                        type="checkbox"
                        // onChange={() => { handleChange({ target: { name: 'machine_status_condition', value: !scheduleParams.machine_status_condition } }) }}
                        disabled
                        checked={item?.machine_status_condition == 'SHOULD_NOT_BE'}
                      />
                      <span disabled className="slider round"></span>
                    </label>
                  </div>
                </div>
              </Form.Group>
            </div>
          </Col>
          <Col xs={2}>
            <i
              className="small material-icons material-symbols-outlined notranslate card_icons edit_icon"
              onClick={() => {
                handleEditClick(item);
              }}>
              edit_square
            </i>
            <i
              className="small material-icons material-symbols-outlined notranslate card_icons delete"
              onClick={() => {
                handleDelete(item);
              }}>
              delete
            </i>
            {/* <i className="small material-icons material-symbols-filled notranslate card_icons add_icon" onClick={()=>{handleAddClick(item)}}>add_circle</i> */}
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div className="schemas">
       <Alert
        className="sidebar-slider_alert"
        show={showToast}
        variant="success"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: '550px',
          zIndex: 9999,
          textAlign: 'center'}}
         onClose={() => setShowToast(false)}
      >
        <p className="text-center">Deleted successfully</p>
      </Alert>
      <MyModal
        show={showModal}
        setHideModal={() => {
          setShowModal(false);
        }}
        handleClose={() => {
          handleClose();
        }}
        formDataProps={dataProps}
        isEdit={editForm}
      />
      <Modal show={deleteModalVisibility} onHide={handleCloseDeleteModal} centered>
        <div className="modal-wrap">
          <Modal.Header closeButton>
            <h5>Delete Alert!</h5>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-grad"
              onClick={() => {
                onAlertDeleteConfirm();
                handleCloseDeleteModal();
              }}>
              Confirm
            </Button>
            <Button variant="secondary" onClick={handleCloseDeleteModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <div className="addNewButton">
        <Button
          className="btn-grad btn btn-primary "
          onClick={() => {
            handleAddClick(null);
          }}>
          Add
        </Button>
      </div>

      {data1[0]?.data?.data?.map((item, index) => (
        <div key={index}>
          <Accordion className="linkAccordion mt-3">
            <Accordion.Item className="base-grey w-auto" eventKey="0">
              <Accordion.Header className="w-auto">
                {' '}
                <div className="active setting_option shadow schedule_header  w-100">
                  <h4>{item?.name}</h4>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <Container className="bg-transparent shopfloor-previous-list ">
                  <CardView item={item} index={index} />
                  {
                    //  data1[0]?.data?.data?.map((item,index) =>{
                    // return cardView(item,index)
                    // })
                  }
                </Container>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      ))}
 
    </div>
  );
};
export default Schemas;
